export default "__VITE_ASSET__DmAdEV8W__"